module.exports = __webpack_public_path__ + "static/media/Home Health Care Service.6b22b509.png";